import React from 'react';

import HowBrandWorksSection from '@rover/react-lib/src/components/HowBrandWorksSection';
import { PetType } from '@rover/types/src/Pet';

import { PageSectionId, useSectionRef } from '../../SeoLocation/hooks/useSectionRef';

interface ServiceLandingHowBrandWorksProps {
  petType?: PetType;
  serviceTypeName?: string;
  providerNounPlural: string;
}

const ServiceLandingHowBrandWorks = ({
  petType,
  serviceTypeName,
  providerNounPlural,
}: ServiceLandingHowBrandWorksProps): JSX.Element => {
  // On mobile the 3 steps stack vertically, so the section is often taller than the
  // viewport itself — even a 0.5 threshold (50% of the whole section at once) is
  // unreachable there. Use a low threshold so "viewed" just means "scrolled into view".
  const sectionRef = useSectionRef(PageSectionId.HowBrandWorks, { threshold: 0.1 });

  return (
    <HowBrandWorksSection
      serviceTypeName={serviceTypeName}
      providerNounPlural={providerNounPlural}
      petType={petType}
      htmlRef={sectionRef}
      headingVariant="display"
    />
  );
};

export default ServiceLandingHowBrandWorks;
